import React from 'react';
const CustomBigDataSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-big-data" });
CustomBigDataSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-big-data sirius-icon-jump-out-big-data-enhance" });
export default CustomBigDataSvg;
